import React from "react";
import "../style/JumboTitleStyle.scss";

const JumboTitleComponent = (props) => {
  const { title, children, className, onClick } = props;

  return (
    <div className={`jumboTitle ${className}`}>
      <span className="title" onClick={onClick}>{title}</span>
      {children}
    </div>
  );
};

export default JumboTitleComponent;
